const ee = "EmploymentEquity";

export const GetSeniorManagersInformation = `${ee}/SeniorManagers`;
export const SaveSeniorManagersInformation = `${ee}/SeniorManagers`;